export function getRandomNumber(min: number, max: number) {
    if (min >= max) {
        throw new Error('Invalid range: min must be less than max.');
    }

    // Calculate the range and add 1 to include the upper bound in the possible results
    const range = max - min + 1;

    // Create an 8-bit unsigned integer array with one element
    const array = new Uint8Array(1);

    // Generate cryptographically secure random values and fill the array with them
    crypto.getRandomValues(array);

    // Convert the random byte to a number in the range 0 to 1
    const randomFraction = array[0] / 255;

    // Map the random fraction to the specified range and add the minimum value
    return Math.floor(randomFraction * range) + min;
}

export function getUniqueRandomNumbersArray(count: number, min: number, max: number) {
    if (count > max - min + 1) {
        throw new Error('Invalid count: count cannot be greater than the range.');
    }

    // Create a Set to store unique random numbers
    const uniqueNumbers = new Set<number>();

    // Array to store the final result of unique random numbers
    const resultArray: number[] = [];

    // Loop until the desired count of unique numbers is reached
    while (uniqueNumbers.size < count) {
        // Generate a random number within the specified range
        const randomNum = getRandomNumber(min, max);

        // Check if the generated random number is not already in the Set (i.e., it is unique)
        if (!uniqueNumbers.has(randomNum)) {
            // Add the unique random number to the Set
            uniqueNumbers.add(randomNum);

            // Add the unique random number to the result array
            resultArray.push(randomNum);
        }
    }

    return resultArray;
}
